'use client'

import NextImage, { type ImageProps } from 'next/image'
import React from 'react'

import { imgproxyEnabled, imgproxyLoader } from '@/utilities/imgproxy'

/**
 * `next/image` with the imgproxy loader already attached.
 *
 * `next/image` is a Client Component, so a Server Component may not pass it a
 * `loader` — functions cannot be serialized across the RSC boundary and React
 * throws at render time ("Functions cannot be passed directly to Client
 * Components"). Attaching the loader inside this client wrapper keeps the
 * function on the client, so the component is safe to render from server and
 * client components alike.
 *
 * Client Components can keep importing `next/image` directly and passing
 * `loader={imgproxyEnabled ? imgproxyLoader : undefined}` themselves.
 */
export const ImgproxyImage: React.FC<ImageProps> = (props) => (
  <NextImage loader={imgproxyEnabled ? imgproxyLoader : undefined} {...props} />
)

export default ImgproxyImage
